import { RootState } from "app/store";
import { PopupTarget } from "./state";
import { Entitlement, ExcuteState, LoadState } from "./types";

// ソフトウェア一覧を取得する
export const selectEntitlements = (state: RootState): Entitlement[] => {
  const { entitlements } = state.software.domains;
  if (!entitlements) {
    return [];
  }
  return entitlements.Entitlements.map(
    (x): Entitlement => ({
      id: x.id,
      pkId: x.pkId,
      productName: x.productName,
      version: x.version,
      licenseModel: x.licenseModel,
      totalQuantity: x.totalQuantity,
      availableQuantity: x.availableQuantity,
      splittedQuantity: x.splittedQuantity,
      usedQuantity: x.usedQuantity,
      creationDate: x.creationDate,
      isTrial: x.isTrial,
      isNodeLocked: x.isNodeLocked,
    })
  );
};

export const selectLoadState = (state: RootState): LoadState =>
  state.software.apps.loading;

export const selectExcuteState = (state: RootState): ExcuteState | undefined =>
  state.software.apps.excuteState;

export const selectPageIndex = (state: RootState): number =>
  state.software.apps.pageIndex;

export const selectMaxPage = (state: RootState): number =>
  state.software.apps.maxPage;

export const selectSearchText = (state: RootState): string =>
  state.software.apps.searchText;

export const selectPopupTarget = (state: RootState): PopupTarget | undefined =>
  state.software.apps.popupTarget;

export const selectTransferTarget = (
  state: RootState
): PopupTarget | undefined => state.software.apps.transferTarget;
